import { render } from "./chat.vue?vue&type=template&id=6028f12d&scoped=true"
import script from "./chat.vue?vue&type=script&lang=ts"
export * from "./chat.vue?vue&type=script&lang=ts"

import "./chat.vue?vue&type=style&index=0&id=6028f12d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6028f12d"

export default script